import React from 'react';
import { Card, CardHeader, CardBody } from '../ui/Card';
import { ClipboardCheckIcon, HeadphonesIcon, TrendingUpIcon, PlaneIcon } from 'lucide-react';
export function WhyDestaMeet() {
  const reasons = [{
    icon: <ClipboardCheckIcon className="h-8 w-8 text-[#0099A1]" data-id="element-267" />,
    title: 'End-to-End Logistics',
    description: 'From flight arrangements to ground transportation, room blocks to event planning - we handle every detail.'
  }, {
    icon: <HeadphonesIcon className="h-8 w-8 text-[#0099A1]" data-id="element-268" />,
    title: 'Local Bilingual Concierge',
    description: 'Our on-site team provides 24/7 support in both English and Spanish to ensure seamless experiences.'
  }, {
    icon: <TrendingUpIcon className="h-8 w-8 text-[#0099A1]" data-id="element-269" />,
    title: 'Premium Value',
    description: 'Exceptional experiences that deliver measurable ROI through increased engagement, retention, and productivity.'
  }, {
    icon: <PlaneIcon className="h-8 w-8 text-[#0099A1]" data-id="element-270" />,
    title: 'Flight Ease',
    description: '~3,000 direct flights/month to CUN; most under 4 hours from major North American hubs.'
  }];
  return <section className="py-16 bg-[#F4E8D0]/30" data-id="element-271">
      <div className="container mx-auto px-4 md:px-6" data-id="element-272">
        <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-273">
          <h2 className="text-3xl md:text-4xl font-bold text-[#374047] mb-4" data-id="element-274">
            Why Choose <span className="text-[#0099A1]" data-id="element-275">DestaMeet</span>
          </h2>
          <p className="text-lg text-[#374047]/80" data-id="element-276">
            The Premier Destination Management Company for transformative
            corporate experiences in Cancun & Riviera Maya.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-277">
          {reasons.map((reason, index) => <Card key={index} className="h-full" data-id="element-278">
              <CardHeader className="flex flex-col items-center text-center" data-id="element-279">
                {reason.icon}
                <h3 className="text-xl font-semibold text-[#374047] mt-4" data-id="element-280">
                  {reason.title}
                </h3>
              </CardHeader>
              <CardBody className="text-center" data-id="element-281">
                <p className="text-[#374047]/80" data-id="element-282">{reason.description}</p>
              </CardBody>
            </Card>)}
        </div>
      </div>
    </section>;
}